import { Stack, Typography, useTheme } from "@mui/material"
import { Dialog } from "@pharmupp/p3-front-commons"
import { AlertCircle } from "react-feather"
import { ChatErrorContent } from "./ChatErrorContent"
import { EmailContent, type EmailContentProps } from "./EmailContent"

type CPMemberCardErrorDialogProps = {
  open: boolean
  onClose: () => void
  userAlreadyExist: boolean
} & EmailContentProps

export const CPMemberCardErrorDialog = ({
  open,
  onClose,
  userFullName,
  userEmail,
  userAlreadyExist,
}: CPMemberCardErrorDialogProps) => {
  const {
    palette: { error },
  } = useTheme()
  const errorColor = error.dark

  return (
    <Dialog
      title="Accès plateforme CSE"
      open={open}
      validateAction={onClose}
      validateText="Retour à la Supervision"
      Icon={AlertCircle}
      iconColor={errorColor}
      width="600px"
      subtitle={
        <Stack alignItems="center" mt={1}>
          <Typography sx={{ color: errorColor }}>
            Nous ne sommes pas parvenus à ouvrir
          </Typography>
          <Typography sx={{ color: errorColor }}>
            l'accès CSE pour ce collaborateur :
          </Typography>
          <Stack
            alignItems="center"
            mt={3}
            color={(theme) => theme.palette.branding.main}
            gap={0.5}
          >
            <Typography variant="18px" fontWeight={600}>
              {userFullName}
            </Typography>
            <Typography>{userEmail}</Typography>
          </Stack>
        </Stack>
      }
    >
      {userAlreadyExist ? (
        <EmailContent userEmail={userEmail} userFullName={userFullName} />
      ) : (
        <ChatErrorContent />
      )}
    </Dialog>
  )
}
